import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from '../../../../../common/svgIcon';

class AccountInfoAccordion extends Component {
    constructor(props) {
        super(props);
        this.onHeaderClick = this.onHeaderClick.bind(this);
        this.state = {
            isExpanded: true,
        };
    }

    onHeaderClick() {
        this.setState({
            isExpanded: !this.state.isExpanded,
        });
    }

    render() {
        const { title, children } = this.props;
        const { isExpanded } = this.state;
        return (
            <div className="bs-accountInfoAccordion">
                <div
                    role="button"
                    tabIndex={0}
                    className="bs-accountInfoAccordion__header"
                    onClick={this.onHeaderClick}
                >
                    <span>{title}</span>
                    <Svg
                        iconName="down"
                        size="Medium"
                        className={classNames(
                            'bs-accountInfoAccordion__headerIcon',
                            { 'bs-accountInfoAccordion__headerIcon_flipVertical': isExpanded },
                        )}
                    />
                </div>
                {
                    isExpanded
                        ? (<div className="bs-accountInfoAccordion__body">{children}</div>)
                        : null
                }
            </div>
        );
    }
}

AccountInfoAccordion.defaultProps = {
    title: null,
    children: null,
};

AccountInfoAccordion.propTypes = {
    title: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

export default AccountInfoAccordion;



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/accountPage/components/accountInfo/components/AccountInfoAccordion.jsx